import { Modelo } from '@ext/index';
import * as Types from './Localidad.types';
import moment, { Moment } from 'moment';
import { IProvincia } from '../Provincias/Provincia.lib';

export class ILocalidad extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public ProvinciaId: number = 0;
    public Nombre: string = '';
    public CodigoPostal: number = 0;
    public Provincia: IProvincia = new IProvincia();

    public get Descripcion(): string {
        return `${this.Nombre.toCapitalCase()} (CP: ${this.CodigoPostal}) ${this.Provincia.Nombre.toCapitalCase()}`;
    }

    public getJson(): any {
        let json: any = {};

        json.id = this.Id;
        json.provincia_id = this.ProvinciaId;
        json.nombre = this.Nombre;
        json.codigo_postal = this.CodigoPostal;


        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.ProvinciaId = !this.Json.provincia_id ? 0 : this.Json.provincia_id;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.CodigoPostal = !this.Json.codigo_postal ? 0 : this.Json.codigo_postal;

        if ( this.Json.provincia )
        {
            this.Provincia = new IProvincia( this.Json.provincia );
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: ILocalidad ) {
        this.Model = Model;
    }

    public Model: ILocalidad;
}